var classActive = 'active';

var element = document.querySelector( '.hoox-sticky-bar-wrapper' );
var targetSections = [
	...document.querySelectorAll( '.hoox-pdp-hero' ),
	document.querySelector( '.b-footer' ),
];

var isInViewport = function ( elem ) {
	var rect = elem.getBoundingClientRect();

	return (
		rect.bottom >= 0 &&
		rect.right >= 0 &&
		rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) &&
		rect.left <= ( window.innerWidth || document.documentElement.clientWidth )
	);
};

window.addEventListener('scroll', function () {
	var isAnySectionInView = false;

	targetSections.forEach(function (section) {
		if (isInViewport(section)) {
			isAnySectionInView = true;
			return;
		}
	});

	if (isAnySectionInView) {
		element.classList.remove(classActive);
	} else {
		element.classList.add(classActive);
	}
});
